const Style = [
  {
    title: 'basico',
    colors: [
      {
        textColor: 'text-green',
        colorSection: 'bg-green',
        colorSectionDark: 'bg-green-dark',
        buttonGradient: 'bg-gradient-to-r from-green to-green-dark/85',
        border: 'border-green',
      }
    ],
    images: [
      {
        line: '/images/lines/greenCircleYellowHook.png',
        circles: '/images/decoration/circlesGroupGreen.svg',
        lineStyle: '-top-[55px] right-0 scale-x-[-1]',
        linePosition: 'scale-x-[-1]',
        image: "/images/programas/basico-v.jpg",
      }
    ],
    sectionColors: [
      {
        sectionColor: 'bg-green/[95%]',
        barColor: 'bg-green-dark/65 shadow-inner',
        underlineColor: 'bg-green-light',
      }
    ],
    sectionImages: [
      {
        line: "/images/lines/greenCircleYellowHook.png",
        circle: "/images/circles/orangeCircle.webp",
        halfDonut: "/images/circles/halfDonutGreen.webp",
        halfCircles: "/images/lines/halfCirclesYellowGreen.png",
        linePosition: 'rotate-180 scale-x-[-1]',
        halfCirclesPosition: 'rotate-180 scale-x-[-1]',
      }
    ]
  },
  {
    title: 'medio',
    colors: [
      {
        textColor: 'text-orange',
        colorSection: 'bg-orange',
        colorSectionDark: 'bg-orange-dark',
        buttonGradient: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
        border: 'border-orange',
      }
    ],
    images: [
      {
        line: '/images/lines/whiteCirclesYellowHook.png',
        circles: '/images/decoration/circlesGroupOrange.svg',
        lineStyle: '-top-[55px] right-0 h-14',
        image: "/images/programas/medio-v.jpg",
      }
    ],
    sectionColors: [
      {
        sectionColor: 'bg-orange/[95%]', 
        barColor: 'bg-[#c03e0d]/45 shadow-inner',
        underlineColor: 'bg-orange-light',
      }
    ],
    sectionImages: [
      {
        line: "/images/lines/whiteCirclesYellowHook.png",
        circle: "/images/circles/orangeCircle.webp",
        halfDonut: "/images/circles/halfDonut.webp",
        halfCircles: "/images/lines/halfCirclesDarkOrangeYellow.png",
      }
    ]
  },
  {
    title: 'profesional',
    colors: [
      {
        textColor: 'text-red',
        colorSection: 'bg-red',
        colorSectionDark: 'bg-red-dark',
        buttonGradient: 'bg-gradient-to-r from-red to-[#CE2341]',
        border: 'border-red',
      }
    ],
    images: [
      {
        line: '/images/lines/redCirclePinkHook.png',
        circles: '/images/decoration/circlesGroupPink.svg',
        lineStyle: '-top-[55px] right-0',
        image: "/images/programas/profesional-v.jpg",
      }
    ],
    sectionColors: [
      {
        sectionColor: 'bg-red opacity-95',
        barColor: 'bg-[#AD222A59] shadow-inner',
        underlineColor: 'bg-[#F4BEA4]',
      }
    ],
    sectionImages: [
      {
        line: "/images/lines/redCirclePinkHook.png",
        circle: "/images/circles/pinkCircle.png",
        halfDonut: "/images/circles/halfDonutPink.png",
        halfCircles: "/images/lines/halfCirclesRedPink.png",
      }
    ]
  },
  {
    title: 'panaderia-y-pasteleria',
    colors: [
      {
        textColor: 'text-yellow',
        colorSection: 'bg-yellow',
        colorSectionDark: 'bg-[#e4a401]',
        buttonGradient: 'bg-gradient-to-r from-yellow to-[#feb601]',
        border: 'border-yellow',
      }
    ],
    sectionColors: [
      {
        sectionColor: 'bg-yellow/[95%]',
        barColor: 'bg-yellow-dark/65 shadow-inner',
        underlineColor: 'bg-yellow-light',
      }
    ],
    images: [
      {
        line: '/images/lines/whiteCirclesYellowHook.png',
        circles: '/images/decoration/circlesGroupOrange.svg',
        lineStyle: '-top-[55px] right-0 h-14',
        image: "/images/programas/pasteleria-v.jpg",
      }
    ]
  },
  {
    title: 'mixologia',
    colors: [
      {
        textColor: 'text-orange',
        colorSection: 'bg-orange',
        colorSectionDark: 'bg-orange-dark',
        buttonGradient: 'bg-orange',
        border: 'border-orange',
      }
    ],
    sectionColors: [
      {
        sectionColor: 'bg-orange/[95%]',
        barColor: 'bg-[#D4572840] shadow-inner',
        underlineColor: 'bg-orange-light',
      }
    ],
    images: [
      {
        line: '/images/lines/whiteCirclesYellowHook.png',
        circles: '/images/decoration/circlesGroupOrange.svg',
        lineStyle: '-top-[55px] right-0 h-14',
        image: "/images/programas/mixologia-v.jpg",
      }
    ],
    sectionImages: [
      {
        line: "/images/lines/whiteCirclesYellowHook.png",
        circle: "/images/circles/orangeCircle.webp",
        halfDonut: "/images/circles/halfDonut.webp",
        halfCircles: "/images/lines/halfCirclesDarkOrangeYellow.png",
      }
    ]
  },
  {
    title: 'barismo',
    colors: [
      {
        textColor: 'text-yellow',
        colorSection: 'bg-yellow',
        colorSectionDark: 'bg-[#e4a401]',
        buttonGradient: 'bg-gradient-to-r from-yellow to-[#feb601]',
        border: 'border-yellow',
      }
    ],
    sectionColors: [
      {
        sectionColor: 'bg-yellow/[95%]',
        barColor: 'bg-yellow-dark/65 shadow-inner',
        underlineColor: 'bg-yellow-light',
      }
    ],
    images: [
      {
        line: '/images/lines/whiteCirclesYellowHook.png',
        circles: '/images/decoration/circlesGroupOrange.svg',
        lineStyle: '-top-[55px] right-0 h-14',
        image: "/images/programas/barismo-v.jpg",
      }
    ]
  },
  {
    title: 'programas',
    content: [
      {
        line1: '/images/lines/longCircles.png',
        line2: '/images/lines/longCircles.png',
        lineHeight: 'h-6',
        buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
        titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
        background: '',
      }
    ]
  },
  {
    title: 'acerca',
    content: [
      {
        background: 'bg-white rounded-br-[53px] py-4 w-max px-44 pr-4',
        line1: '/images/lines/longCircles.png',
        line2: '/images/lines/longCircles.png',
        lineHeight: 'h-6',
        buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
        titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0'
      }
    ]
  },
  {
    title: 'eventos',
    content: [
      {
        line1: '/images/lines/longCirclesPink.svg',
        line2: '',
        lineHeight: 'h-10 md:h-16',
        buttonColor: 'bg-gradient-to-r from-[#CE2341] to-[#EE3E5D]',
        titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-red after:w-full after:-bottom-2 after:right-0',
        background: '',
        footerLine: '/images/lines/redCirclePinkHook.png',
      }
    ]
  },
  {
    title: 'instalaciones',
    content: [
      {
        line1: '/images/lines/longCircles.png',
        line2: '/images/lines/longCircles.png',
        lineHeight: 'h-6',
        buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
        titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
        background: ''
      }
    ]
  },
  {
    title: 'basico',
    content: [
      {
        line1: '/images/lines/longCircles.png',
        line2: '/images/lines/longCircles.png',
        lineHeight: 'h-6',
        buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
        titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
        background: ''
      }
    ]
  },
  {
    title: 'default',
    content: [
      {
        line1: '/images/lines/longCircles.png',
        line2: '/images/lines/longCircles.png',
        lineHeight: 'h-6',
        buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
        titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
        background: ''
      }
    ]
  }
]

export default Style;